














import { defineComponent, ref, PropType } from 'vue-demi';
import { NavTabs, NavTabsInfo } from '@tencent/wphk-ui';

export default defineComponent({
  name: 'MallNavTabs',
  components: {
    NavTabs,
  },
  emits: ['change'],
  props: {
    list: {
      type: Array as PropType<NavTabsInfo[]>,
      required: true,
    },
  },
  setup(props, context) {
    const navTab = ref<InstanceType<typeof NavTabs> | null>(null);
    // 设置点击滚动边缘触发的距离，点击项离2端小于这个距离会自动滚动展示隐藏项
    const scrollOffset = ref(100);

    function handleChanged(nav) {
      context.emit('change', nav.id);
    }

    function switchTo(id: string) {
      if (navTab.value) {
        navTab.value.switchNavTab(id);
      }
    }

    return {
      navTab,
      scrollOffset,
      handleChanged,
      switchTo,
    };
  },
});
